import { render, staticRenderFns } from "./BbeeProductosServiciosCM.vue?vue&type=template&id=62cce6b1"
import script from "./BbeeProductosServiciosCM.vue?vue&type=script&lang=js"
export * from "./BbeeProductosServiciosCM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports